import { Component, h, Host, JSX, Prop } from "@stencil/core";
import { navContentStore } from "@phn/state/nav-content-store";
import {
  NavigationMode,
  NavigationModeType,
  NavigationTheme,
  NavigationThemeType,
} from "@phn/utility/constants";
import { getRightTheme } from "@phn/utility/helper";
import { sendBurguerButtonDataLayerEvent } from "@phn/services/analytics/component-events/burguer-button";
import { constructThemeClass } from "../../utility/helper";

@Component({
  tag: "phn-burger-button",
  styleUrl: "burger-button.scss",
  scoped: true,
})
export class BurgerButton {
  @Prop() hideLabel!: boolean;

  @Prop() alignLabel!: string;

  @Prop() isLoading = false;

  @Prop() theme: NavigationThemeType = NavigationTheme.light;

  @Prop() mode: NavigationModeType = NavigationMode.navbar;

  render(): JSX.Element {
    const { menu } = navContentStore.state;

    return (
      <Host class={`${constructThemeClass(this.mode, this.theme)}-theme`}>
        <div class="tooltip">
          <phn-p-button-pure
            class="phn-burger-button"
            theme={getRightTheme(this.theme, this.mode)}
            onClick={() => sendBurguerButtonDataLayerEvent(menu)}
            aria={{ "aria-haspopup": "dialog", "aria-label": "open the menu" }}
            align-label={this.alignLabel}
            icon="menu-lines"
            size="inherit"
            hideLabel={this.hideLabel}
          >
            {menu.text}
          </phn-p-button-pure>
        </div>
      </Host>
    );
  }
}
